module.exports = __webpack_public_path__ + "img/wz-8-2-3.7a4ddc9b.jpg";